// extracted by mini-css-extract-plugin
module.exports = {"boxStyle":"Skills_boxStyle__2Gqra","rightBox":"Skills_rightBox__3unxW","iconBox":"Skills_iconBox__1FcU1","img":"Skills_img__3rWXU","skillsTitle":"Skills_skillsTitle__NIxDd"};